import { jsx as _jsx } from "react/jsx-runtime";
import { closeDialog, useDialogStore, } from '@common/ui/overlays/store/dialog-store';
import { DialogTrigger } from '@common/ui/overlays/dialog/dialog-trigger';
export function DialogStoreOutlet() {
    const { dialog: DialogElement, data } = useDialogStore();
    return (_jsx(DialogTrigger, { type: "modal", isOpen: DialogElement != null, onClose: value => {
            closeDialog(value);
        }, children: DialogElement ? _jsx(DialogElement, { ...data }) : null }));
}
